import { LevelSuffix, Paragraph } from "docx";
import { paragraphArial } from "./paragraphs";

export const leseschwache = (leseschwaeche) => {
  const leseSchw = () => {
    return [
      new Paragraph(""),
      paragraphArial(
        "Bei der Sprachverwendung wurden lediglich Grammatik und Zeichensetzung bewertet, die Rechtschreibung wurde nicht bewertet."
      ),
    ];
  };
  return leseschwaeche ? leseSchw() : [];
};
